/**
 * @Author: v_jppjpeng
 * @Date: 2024-12-02 09:53:39
 * @Explain: 自动化活动
 */

export default {
  // 列表
  'ACTIVITY.AUTO.WELCOME.TITLE': '欢迎新用户',
  'ACTIVITY.AUTO.WELCOME.DESC':
    '设置自动发件旅程，当特定来源的联系人加入SmartLink联系人列表时，向他们发送欢迎电子邮件，给他们留下良好的第一印象。',
  'ACTIVITY.AUTO.LIST': '自动化活动',
  'ACTIVITY.AUTO.LIST.START.CREATE': '开始创建',
  'ACTIVITY.AUTO.LIST.CREATE.AUTO.JOURNEY': '创建自动化旅程',
  'ACTIVITY.AUTO.LIST.JOURNEY.NAME': '旅程名称',
  'ACTIVITY.AUTO.LIST.JOURNEY.NAME.PLACEHOLDER': '输入旅程名称',
  'ACTIVITY.AUTO.LIST.TITLE': '旅程列表',
  'ACTIVITY.AUTO.LIST.NAME': '旅程名称',
  'ACTIVITY.AUTO.LIST.CONTACTS.SENT.NUMBER': '已发送联系人数量',
  'ACTIVITY.AUTO.LIST.TIME': '旅程激活时间',
  'ACTIVITY.AUTO.LIST.UPDATER': '上次更新人',
  'ACTIVITY.AUTO.LIST.STATUS': '状态',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.TITLE': '暂停详情',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.DESC.1.1':
    '<span style="color: #fff; opacity: 0.8">暂停时间：</span> {suspensionDays}天',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.DESC.1.2':
    '<span style="color: #fff; opacity: 0.8">暂停时间：</span> {suspensionHours}小时',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.DESC.1.3':
    '<span style="color: #fff; opacity: 0.8">暂停时间：</span> {suspensionDays}天{suspensionHours}小时',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.DESC.2':
    '<span style="color: #fff; opacity: 0.8">堆积联系人数量：</span> {num}',
  'ACTIVITY.AUTO.LIST.STATUS.ONGOING': '进行中',
  'ACTIVITY.AUTO.LIST.STATUS.NOT.ACTIVITE': '未激活',
  'ACTIVITY.AUTO.LIST.STATUS.SUSPENDED': '暂停中',
  'ACTIVITY.AUTO.LIST.STATUS.TERMINATED': '已终止',
  'ACTIVITY.AUTO.LIST.ACTION.DETAILS': '旅程详情',
  'ACTIVITY.AUTO.LIST.ACTION.REVISE.ERROR': '处理异常',
  'ACTIVITY.AUTO.LIST.SUSPEND.TITLE': '确认暂停旅程么？',
  'ACTIVITY.AUTO.LIST.SUSPEND.DESC':
    '<div class="color-666"><p>旅程暂停后可修改旅程配置，重新开始可按新配置发件。</p><p style="padding-top: 16px">暂停可能会导致联系人堆积在旅程内未发送邮件，请尽快开启。</p></div>',
  'ACTIVITY.AUTO.LIST.START.TITLE': '旅程开启确认',
  'ACTIVITY.AUTO.LIST.START.DESC':
    "<div class='color-666'><p>开启后，将按最新设置进行。</p><p style='padding-top: 16px'>旅程已暂停 {suspendSecond}小时，产生{contactsBacklog}个联系人堆积在旅程内。重启后，可开启补发机制，按暂停前的旅程设置补发堆积的联系人。</p></div>",
  'ACTIVITY.AUTO.LIST.START.ACTIVATE': '激活补发机制',
  'ACTIVITY.AUTO.LIST.DEL.TITLE': '请确认是要删除旅程',
  'ACTIVITY.AUTO.LIST.DEL.DESC':
    "旅程 <b class='color-333'>{name}</b>删除后不可恢复，请谨慎操作",
  'ACTIVITY.AUTO.LIST.STOP.TITLE': '请确认是否要终止旅程？',
  'ACTIVITY.AUTO.LIST.STOP.DESC':
    "<div><p>旅程<b class='color-333'>{name}</b>终止后不可重新开始，请谨慎操作。</p><p style='padding-top: 16px'>如需修改配置可暂停后重启。</p><div>",

  // 创建、编辑
  'ACTIVITY.AUTO.SAVE.ACTIVATE': '保存并激活旅程',
  'ACTIVITY.AUTO.JOURNEY.IS': '<span>旅程</span>',
  'ACTIVITY.AUTO.PLEASE.CHECK': '请检查',
  'ACTIVITY.AUTO.CHECK.JOURNEY.CONFIG': '<span>旅程配置</span>',
  'ACTIVITY.AUTO.CLICK.START.SETTING': '点击此处开始自动化设置',
  'ACTIVITY.AUTO.CONTACTS.SOURCE': '联系人来自于',
  'ACTIVITY.AUTO.CONTACTS.SOURCE.TIPS': '请选择联系人来源',
  'ACTIVITY.AUTO.CONTACT.SOURCE.HSA.BEEN.SET': '联系人来源设置成功',
  'ACTIVITY.AUTO.DOUBLE.OPT.IN.SETTING': '双重确认订阅设置',
  'ACTIVITY.AUTO.DOUBLE.OPT.IN.HAVE.SET': '双重确认邮件设置成功',
  'ACTIVITY.AUTO.DOUBLE.OPT.IN.TIPS':
    '可选择是否对上述来源的联系人发送二次确认订阅邮件',
  'ACTIVITY.AUTO.WELCOME.EMAIL.SETTING': '欢迎邮件设置',
  'ACTIVITY.AUTO.WELCOME.EMAIL.HAVE.SET': '欢迎邮件设置成功',
  'ACTIVITY.AUTO.WELCOME.EMAIL.SETTING.TIPS':
    '可选择是否对上述来源的联系人发送欢迎邮件',
  'ACTIVITY.AUTO.WELCOME.EMAIL.NO.SEND.TIPS': '无需发送',
  'ACTIVITY.AUTO.WAIT.TIME': '等待一段时间',
  'ACTIVITY.AUTO.WAIT.TIME.SETTING.TITLE': '延迟多久才流转联系人',
  'ACTIVITY.AUTO.WAIT.TIME.DELAY.FOR': '延迟',

  // 编辑 - 联系人来自于
  'ACTIVITY.AUTO.JOURNEY.CONFIGURED.NAME': '在"{name}"旅程中已配置',
  'ACTIVITY.AUTO.SOURCE.HAS.BEEN.DELETED':
    '<div class="del-name">{name}</div> 已被删除',

  // 表现统计
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE': '旅程表现',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.CONTACT.SOURCE': '联系人来源',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.TOTAL.CONTACT': '此来源的联系人总数',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.DOUBLE.OPT.IN': '双重确认邮件',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.WELCOME.EMAIL': '欢迎邮件',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.SENT': '已发送',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.DELIVERED': '已送达',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.OPENED': '已打开',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.CONFIRM': '已确认',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.CLICKED': '已点击',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.UNSUBSCRIBE': '取消订阅',

  // 双重确认订阅设置
  'OPT.IN.SETTINGS.SECONDARY.CONFIRM.SET': '双重确认订阅已设置',
  'OPT.IN.SETTINGS.TITLE': '为哪些API和表单来源用户的设置？',
  'OPT.IN.SETTINGS.SINGLE.TITLE': '单次确认加入',
  'OPT.IN.SETTINGS.SINGLE.DESC':
    '<b>单次确认加入</b> 表示邮箱会直接被加入营销订阅列表。',
  'OPT.IN.SETTINGS.DOUBLE.TITLE': '双重确认加入',
  'OPT.IN.SETTINGS.DOUBLE.DESC1':
    '<b>双重确认加入</b> 表示一封“双重选择加入”的邮件会立即发送给订阅者，只有当订阅者在邮件内再次确认加入时，其才会被加入营销订阅列表。',
  'OPT.IN.SETTINGS.DOUBLE.DESC2':
    '“双重选择加入”只适用在通过api、首次以订阅状态添加到订阅列表时的情况。任何对已存在联系人的信息更新不适用此流程。',
  'OPT.IN.SETTINGS.METHOD': '选择加入方式',
  'OPT.IN.SETTINGS.METHOD.SINGLE.TITLE': '单次确认加入',
  'OPT.IN.SETTINGS.METHOD.SINGLE.DESC':
    '当联系人被API或表单以订阅状态首次添加到您的订阅列表时，其立即被更新为已订阅状态，并可以收到营销邮件。',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.TITLE': '特定地区玩家双重确认加入',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.TIPS':
    '{country}。在上述国家/地区，法律要求“双重选择加入”。',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.DESC1':
    '仅特定地区的联系人首次通过API或表单添加到您的列表中，并具有订阅的状态时，会向该联系人发送一封电子邮件，以确认其订阅意向。',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.DESC2':
    '确认订阅后，联系人的订阅状态才会从“待定”更改为“已订阅”。',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.ALL.TITLE': '所有地区玩家双重确认加入',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.ALL.DESC1':
    '所有地区的联系人首次通过API或表单添加到您的列表中，并具有订阅的状态时，会向该联系人发送一封电子邮件，以确认其订阅意向。',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.ALL.DESC2':
    '确认订阅后，联系人的订阅状态才会从“待定”更改为“已订阅”。',
  'OPT.IN.SETTINGS.CONFIRM.EMAIL.SETTINGS': '设置发件信息和邮件内容',
  'OPT.IN.SETTINGS.SELECT.DEFAULT.TEMPLATE': '使用默认模板',
  'OPT.IN.SETTINGS.SELECT.MARKETING.TEMPLATE': '从营销邮件模板中选择模板',
  'OPT.IN.SETTINGS.SENDING.INFO': '发送人信息',
  'OPT.IN.SETTINGS.SUBJECT.LINE': '主题',
  'OPT.IN.SETTINGS.SUBJECT.LINE.PLACEHOLDER': '在这里输入主题',
  'OPT.IN.SETTINGS.SUBJECT.CONFIRM.SUBSCRIPTION': '请确认是否订阅',
  'OPT.IN.SETTINGS.CONTACT.EMAIL': '联系邮箱',
  'OPT.IN.SETTINGS.PLEASE.ENTER.CONTACT.EMAIL': '请输入联系邮箱',
  'OPT.IN.SETTINGS.CONTACT.EMAIL.PLACEHOLDER':
    '给用户提供一个可以联系的邮箱地址',
  'OPT.IN.SETTINGS.PREVIEW.TITLE': '预览确认邮件',
  'OPT.IN.SETTINGS.TO.ME': '发送至 我',
  'OPT.IN.SETTINGS.CONFIRM.SAVE.TIPS': '当前内容未保存，是否保存？',
  'OPT.IN.SETTINGS.TEMPLATE.MISSING.BUILT.IN.LINK.TIPS':
    '激活失败，缺失内置链接。请检查{language}下邮件模板',

  // opt-in 欢迎邮件设置
  'ACTIVITY.AUTO.WELCOME.EMAIL.DESC1':
    '欢迎邮件在玩家完成邮件订阅后发送，可帮助游戏和玩家快速建立情感链接',
  'ACTIVITY.AUTO.WELCOME.EMAIL.DESC2':
    '欢迎邮件在旅程中和二次确认邮件是否发送无关，只和进入旅程的联系人的订阅状态有关',
  'ACTIVITY.AUTO.WELCOME.EMAIL.DESC3':
    '其中双重邮件发送的玩家需要确认订阅，其订阅状态才会变为已订阅，才会接收到欢迎邮件',
  'ACTIVITY.AUTO.WELCOME.EMAIL.YES': '此来源联系人加入后需要发送欢迎邮件',
  'ACTIVITY.AUTO.WELCOME.EMAIL.NO': '此来源联系人无需发送欢迎邮件',
};
